import { render, staticRenderFns } from "./NetworkView.vue?vue&type=template&id=6a54f4d0&scoped=true"
import script from "./NetworkView.vue?vue&type=script&lang=js"
export * from "./NetworkView.vue?vue&type=script&lang=js"
import style0 from "./NetworkView.vue?vue&type=style&index=0&id=6a54f4d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a54f4d0",
  null
  
)

export default component.exports